// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomOption {
  cursor: pointer;
  display: inline-flex;
  width: auto;
}

.input-container {
  border-bottom: 2px solid #e7e7e7;
  margin: auto;
  padding-top: .3rem;
  margin-left: .8rem;
}

.input-container:focus-within {
  border-bottom-color: #000000;
}

.CustomOption input[type="text"] {
  outline: none;
  border: none;
  line-height: normal;
}

.has-error .CustomOption {
  color: #c12929;
  opacity: 1;
}

.has-error .input-container {
  border-bottom-color: #c12929;
}

.has-error .input[type="text"]::placeholder {
  color: #c12929;
}

.checkbox-container {
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  width: 1.4rem;
  height: 1.4rem;
  flex-shrink: 0;
}

.textbox-container {
  display: inline-flex;
}

.textbox-container > span:first-child {
  margin: auto;
  padding-top: 4px;
  padding-left: .8rem;
}

.checkbox-outer-box {
  box-sizing: border-box;
  height: 1.4rem;
  left: 0;
  position: absolute;
  top: 0;
  transition: opacity ease-in-out 280ms;
  width: 1.4rem;
  border-width: .15rem;
  border-style: solid;
  border-radius: 20%;
  opacity: .5;
}

.checkbox-inner-box {
  box-sizing: border-box;
  height: 1.4rem;
  left: 0;
  position: absolute;
  top: 0;
  transition:
    opacity ease-in-out 280ms,
    background-color ease-in-out 280ms;
  width: 1.4rem;
  background-color: #000000;
  transform: scale(.8);
  opacity: 0;
}

.checked .checkbox-inner-box {
  opacity: 1;
}

.checked .checkbox-outer-box {
  opacity: 1;
}

.checked .checkbox-inner-box::after {
  content: '\\2713';
  font-weight: 500;
  font-size: 1.2rem;
  color: #ffffff;
  position: absolute;
  top: .15rem;
  left: .2rem;
}

.checked .textbox-container > span {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/CustomOption.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,qCAAqC;EACrC,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN;;sCAEoC;EACpC,aAAa;EACb,yBAAyB;EACzB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".CustomOption {\n  cursor: pointer;\n  display: inline-flex;\n  width: auto;\n}\n\n.input-container {\n  border-bottom: 2px solid #e7e7e7;\n  margin: auto;\n  padding-top: .3rem;\n  margin-left: .8rem;\n}\n\n.input-container:focus-within {\n  border-bottom-color: #000000;\n}\n\n.CustomOption input[type=\"text\"] {\n  outline: none;\n  border: none;\n  line-height: normal;\n}\n\n.has-error .CustomOption {\n  color: #c12929;\n  opacity: 1;\n}\n\n.has-error .input-container {\n  border-bottom-color: #c12929;\n}\n\n.has-error .input[type=\"text\"]::placeholder {\n  color: #c12929;\n}\n\n.checkbox-container {\n  box-sizing: border-box;\n  display: inline-block;\n  position: relative;\n  width: 1.4rem;\n  height: 1.4rem;\n  flex-shrink: 0;\n}\n\n.textbox-container {\n  display: inline-flex;\n}\n\n.textbox-container > span:first-child {\n  margin: auto;\n  padding-top: 4px;\n  padding-left: .8rem;\n}\n\n.checkbox-outer-box {\n  box-sizing: border-box;\n  height: 1.4rem;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: opacity ease-in-out 280ms;\n  width: 1.4rem;\n  border-width: .15rem;\n  border-style: solid;\n  border-radius: 20%;\n  opacity: .5;\n}\n\n.checkbox-inner-box {\n  box-sizing: border-box;\n  height: 1.4rem;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition:\n    opacity ease-in-out 280ms,\n    background-color ease-in-out 280ms;\n  width: 1.4rem;\n  background-color: #000000;\n  transform: scale(.8);\n  opacity: 0;\n}\n\n.checked .checkbox-inner-box {\n  opacity: 1;\n}\n\n.checked .checkbox-outer-box {\n  opacity: 1;\n}\n\n.checked .checkbox-inner-box::after {\n  content: '\\2713';\n  font-weight: 500;\n  font-size: 1.2rem;\n  color: #ffffff;\n  position: absolute;\n  top: .15rem;\n  left: .2rem;\n}\n\n.checked .textbox-container > span {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
